module.exports = __webpack_public_path__ + "static/ogp-privacy-policy-e561d58eddc453e2e3a56ddfaefd17af.png";